import React from 'react';

import FilterPanel from '../../common/FilterPanel';
import FlatFilterSection from '../../common/FlatFilterSection';
import UnitFilterSection from '../../common/UnitFilterSection';

import {
  GameFilter,
  GameUnitFilter,
  GameFilterField,
} from '../types';

interface Props {
  filters: GameFilter;
  onFilterChange: (newFilters: GameFilter) => void;
}

const sectionTitle = (title: string) => (
  <div className="body tw-my-2 tw-font-bold tw-text-tci-black !tw-leading-[18px]">{title}</div>
);

const FilterBar = ({ filters, onFilterChange }: Props) => {
  const handleLessonChange = (value: string | number, checked: boolean) => {
    const newFilters = { ...filters };
    newFilters.unit?.forEach((unitFilter) => {
      const lesson = unitFilter.lessons.find(l => l.value === value);
      if (lesson) lesson.checked = checked;
    });

    newFilters.lesson?.forEach((lessonFilter) => {
      // eslint-disable-next-line no-param-reassign
      if (lessonFilter.value === value) lessonFilter.checked = checked;
    });

    onFilterChange(newFilters);
  };

  const handleUnitChange = (oldUnit: GameUnitFilter, checked: boolean) => {
    const newFilters = { ...filters };
    const newLessons = oldUnit.lessons.map(lesson => ({ ...lesson, checked }));

    newFilters.unit?.forEach((unitFilter) => {
      // eslint-disable-next-line no-param-reassign
      if (unitFilter.label === oldUnit.label) unitFilter.lessons = newLessons;
    });

    onFilterChange(newFilters);
  };

  const handleCategoryChange = (value: string | number, checked: boolean) => {
    const newFilters = { ...filters };
    const newCategory = newFilters.category.find(c => c.value === value);
    if (newCategory) newCategory.checked = checked;
    onFilterChange(newFilters);
  };

  const handleStatusChange = (value: string | number, checked: boolean) => {
    const newFilters = { ...filters };
    const newStatus = newFilters.status.find(s => s.value === value);
    if (newStatus) newStatus.checked = checked;
    onFilterChange(newFilters);
  };

  const handleFilterClear = () => {
    const newFilters = { ...filters };
    const setUnchecked = (filter: GameFilterField) => {
      // eslint-disable-next-line no-param-reassign
      filter.checked = false;
    };

    newFilters.unit?.forEach(unitFilter => unitFilter.lessons.forEach(setUnchecked));
    newFilters.lesson?.forEach(setUnchecked);
    newFilters.category.forEach(setUnchecked);
    newFilters.status.forEach(setUnchecked);

    onFilterChange(newFilters);
  };

  return (
    <FilterPanel topClassName="tw-top-4" onClear={handleFilterClear}>
      {!!filters.unit?.length && (
        <UnitFilterSection
          title={sectionTitle('Unit')}
          units={filters.unit}
          onLessonChange={handleLessonChange}
          onUnitChange={handleUnitChange}
        />
      )}

      {!!filters.lesson?.length && (
        <FlatFilterSection
          filterClassName="alignCenter"
          filters={filters.lesson}
          title={sectionTitle('Lesson')}
          onChange={handleLessonChange}
        />
      )}

      {!!filters.category.length && (
        <FlatFilterSection
          filterClassName="alignCenter"
          filters={filters.category}
          title={sectionTitle('Category')}
          onChange={handleCategoryChange}
        />
      )}

      <FlatFilterSection
        filterClassName="alignCenter"
        filters={filters.status}
        title={sectionTitle('Status')}
        onChange={handleStatusChange}
      />
    </FilterPanel>
  );
};

export default FilterBar;
